{
  "search": {
    "header": "Tømmerkjøper",
    "searchFieldLabel": "Søk etter navn, kundenummer, kjøpernummer eller organisasjonsnummer",
    "searchButton": "Søk",
    "registerButton": "Registrer tømmerkjøper",
    "columns": {
      "name": "Navn",
      "customerNumber": "Kundenummer",
      "buyerNumber": "Kjøpernummer",
      "organizationNumber": "Organisasjonsnummer",
      "lineOfBusiness": "Bransje"
    },
    "deactivatedBadge": "Deaktivert"
  },
  "contactPreferences": {
    "pageTitle": "Kontaktpreferanser",
    "sectionTitle": "Faktura",
    "backNavText": "Tilbake til oversikt",
    "rows": {
      "standardInvoice": "Ordinær faktura",
      "standardInvoiceDescription": "Gjelder alle fakturaer som ikke er virkesfaktura",
      "timberInvoice": "Virkesfaktura",
      "timberInvoiceDescription": "Faktura knyttet til salget og oppgjøret for tømmer/virke som er levert eller solgt"
    },
    "methods": {
      "ehf": "EHF",
      "email": "E-post",
      "paper": "Brev"
    },
    "restrictions": {
      "title": "Noen valg er ikke tilgjengelige",
      "titles": {
        "paper": "Brev er ikke tilgjengelig",
        "email": "E-post er ikke tilgjengelig",
        "ehf": "EHF er ikke tilgjengelig"
      },
      "missingPostalAddress": "Tømmerkjøperen har ikke adresse.",
      "missingEmail": "Tømmerkjøperen har ikke e-post adresse.",
      "missingOrganizationNumber": "Tømmerkjøperen har ikke organisasjonsnummer.",
      "ehfUnavailableFictiveOrg": "Tømmerkjøperen har et fiktivt organisasjonsnummer som ikke støtter EHF.",
      "ehfUnauthorized": "EHF er midlertidig deaktivert inntil avklaringer om tilgang er ferdigstilt."
    },
    "saveButton": "Lagre endringer",
    "savingButton": "Lagrer endringer",
    "saveErrorTitle": "Kunne ikke lagre kontaktpreferanser",
    "saveErrorDescription": "En feil oppstod ved lagring av kontaktpreferanser. Prøv igjen.",
    "loadError": "Kunne ikke hente kontaktpreferanser"
  },
  "deliveryLocations": {
    "pageTitle": "Mottakssteder",
    "backNavigation": "Tilbake til oversikt",
    "cardTitle": "Kjøpernummer {{vsysNumber}}",
    "subtitle": "Mottaksstedene blir hentet fra Skogdata for dette kjøpernummeret",
    "loading": "Laster mottakssteder...",
    "empty": "Ingen mottakssteder er registrert for dette kjøpernummeret",
    "errorTitle": "Kunne ikke hente mottakssteder",
    "errorDescription": "En feil oppstod ved henting av mottakssteder. Prøv igjen.",
    "table": {
      "internalNumber": "Internnummer",
      "name": "Sted"
    }
  },
  "profile": {
    "identifiers": {
      "buyerNumber": "Kjøpernummer",
      "organizationNumber": "Organisasjonsnummer",
      "fictionalOrganizationNumber": "Fiktivt organisasjonsnummer"
    },
    "tabs": {
      "ariaLabel": "Tømmerkjøpernavigasjon",
      "overview": "Oversikt",
      "salesAgreements": "Salgsavtaler"
    },
    "partnerData": {
      "edit": "Endre tømmerkjøperopplysninger",
      "contact": {
        "title": "Kontaktinformasjon",
        "phone": "Telefon",
        "email": "E-post"
      },
      "invoice": {
        "title": "Fakturainformasjon",
        "recipient": "Mottaker",
        "email": "Faktura e-post",
        "address": "Adresse",
        "country": "Land"
      },
      "transport": {
        "title": "Transportinformasjon",
        "responsible": "Transportansvarlig",
        "payer": "Transportbruker",
        "measurementOrganization": "Måleorganisasjon"
      },
      "customerResponsible": {
        "title": "Kundeansvarlig",
        "companyResponsible": "Bedriftsansvarlig"
      }
    },
    "statusToggle": {
      "menuAriaLabel": "Flere handlinger",
      "menuDeactivate": "Deaktiver tømmerkjøper",
      "menuActivate": "Gjenopprett tømmerkjøper",
      "inactiveAlert": {
        "title": "Tømmerkjøperen er deaktivert",
        "description": "Deaktiverte profiler kan ikke velges for oppdrag før de blir gjenopprettet",
        "action": "Gjenopprett tømmerkjøper"
      },
      "errorTitle": "Kunne ikke oppdatere status",
      "error": "En feil oppstod ved oppdatering av tømmerkjøper-status. Prøv igjen."
    },
    "error": {
      "title": "Kunne ikke hente tømmerkjøper",
      "description": "Det oppstod en feil ved henting av tømmerkjøperprofil.",
      "goToOverview": "Gå til tømmerkjøper oversikt"
    },
    "remark": {
      "title": "Merknad",
      "edit": "Endre merknad",
      "empty": "Ingen merknad registrert"
    },
    "actions": {
      "title": "Status",
      "activate": "Aktiver tømmerkjøper",
      "deactivate": "Deaktiver tømmerkjøper",
      "statusDescription": "Knappen bruker samme aktiver/deaktiver-flyt når statusendring kobles opp."
    },
    "quickActions": {
      "contactPreferences": {
        "title": "Kontaktpreferanser",
        "description": "Endre tømmerkjøpers kontaktvalg"
      },
      "deliveryLocations": {
        "title": "Mottakssteder",
        "description": "Registrerte mottakssteder"
      },
      "visma": {
        "title": "Regnskap",
        "description": "Åpne kundesiden i Visma Accounting"
      }
    },
    "salesAgreements": {
      "title": "Salgsavtaler",
      "description": "Oversikt over salgsavtaler til tømmerkjøperen",
      "detail": {
        "agreementNumberLabel": "Salgsavtalenummer",
        "copyText": "Kopier",
        "copiedText": "Kopiert",
        "agreementInfo": {
          "title": "Avtaleinformasjon",
          "period": "Avtaleperiode",
          "responsibleEmployee": "Ansvarlig ansatt",
          "lastModified": "Sist oppdatert",
          "created": "Opprettet",
          "ediStatus": "EDI-status",
          "soRef": "SO-ref",
          "vsysPricelistNumber": "VSYS-prisliste"
        },
        "transportInfo": {
          "title": "Transportinformasjon",
          "transportResponsible": "Transportansvarlig",
          "transportPayer": "Transportbruker",
          "measurementOrganization": "Måleorganisasjon",
          "deliveryLocations": "Mottakssteder",
          "overflowLink": "+{{count}} til"
        },
        "status": {
          "title": "Status"
        },
        "inactiveAlert": {
          "title": "Salgsavtalen er deaktivert",
          "description": "Deaktiverte salgsavtaler kan ikke kobles til oppdrag.\nOppdrag en salgsavtale var koblet til før den ble deaktivert vil kunne leveres på som vanlig.",
          "action": "Gjenopprett salgsavtale"
        },
        "editButton": "Endre informasjon",
        "drawer": {
          "title": "Mottakssteder",
          "description": "Oversikt over mottakssteder i salgsavtalen",
          "close": "Lukk"
        },
        "actions": {
          "viewDetails": "Vis detaljer"
        },
        "detailsDrawer": {
          "title": "Detaljer",
          "close": "Lukk",
          "fields": {
            "measurementAndTransportOrderIssuer": "Utsteder av måle- og transportoppdrag",
            "recipientOrderNumber": "Varemottakers bestillingsnummer",
            "commission": "Provisjon",
            "measurementCostsNotRefunded": "Målekostnader skal refunderes",
            "certificationType": "Sertifiseringstype",
            "certificateText": "Sertifikattekst"
          },
          "issuerValues": {
            "none": "Ingen",
            "seller": "Selger",
            "buyer": "Kjøper"
          },
          "booleanValues": {
            "yes": "Ja",
            "no": "Nei"
          },
          "certificationValues": {
            "none": "Ikke angitt",
            "pefc": "PEFC",
            "fsc": "FSC",
            "pefcAndFsc": "PEFC / FSC",
            "other": "Annet"
          }
        }
      },
      "filters": {
        "allStatuses": "Vis alle statuser",
        "ariaLabel": "Filtrer salgsavtaler på status"
      },
      "errorDescription": "Det oppstod en feil ved henting av salgsavtaler. Prøv igjen.",
      "columns": {
        "status": "Status",
        "ediStatus": "EDI-status",
        "soRef": "SO-ref",
        "name": "Avtalenavn",
        "period": "Periode",
        "lastModified": "Sist endret",
        "created": "Opprettet",
        "actions": "Handlinger"
      },
      "statusValues": {
        "planned": "Planlagt",
        "ongoing": "Pågående",
        "completed": "Fullført",
        "deactivated": "Deaktivert"
      },
      "ediStatusValues": {
        "notSent": "Ikke sendt",
        "sent": "Sendt",
        "error": "Feil",
        "confirmed": "Bekreftet"
      },
      "actions": {
        "ariaLabel": "Flere handlinger for salgsavtale",
        "edit": "Endre informasjon",
        "copyLastPricePeriod": "Kopier siste prisperiode til ny salgsavtale",
        "activate": "Gjenopprett salgsavtale",
        "deactivate": "Deaktiver salgsavtale",
        "delete": "Slett"
      },
      "deleteDialog": {
        "confirm": {
          "title": "Er du sikker på at du vil slette {{name}}?",
          "description": "Alle prisperioder i salgsavtalen vil gå tapt og må opprettes på nytt.",
          "cancel": "Avbryt",
          "action": "Slett"
        },
        "blocked": {
          "title": "Kan ikke slette {{name}}",
          "description": "Salgsavtalen er eller har vært tilkoblet ett eller flere oppdrag. Den kan derfor ikke slettes med tanke på historikk. Ønsker du å skjule den kan du sette den som deaktivert. ",
          "ok": "Lukk"
        },
        "errorTitle": "Kunne ikke slette salgsavtalen",
        "errorDescription": "En feil oppstod ved sletting av salgsavtalen. Prøv igjen."
      },
      "deactivationDialog": {
        "confirm": {
          "title": "Ønsker du å deaktivere {{name}}?",
          "description": "Deaktiverte salgsavtaler kan ikke kobles til oppdrag. Oppdrag en salgsavtale var koblet til før den deaktivert vil kunne leveres på som vanlig.",
          "cancel": "Avbryt",
          "action": "Deaktiver salgsavtale"
        },
        "errorTitle": "Handlingen kunne ikke fullføres",
        "errorDescription": "Det er for tiden tekniske problemer. Prøv igjen senere."
      },
      "restoreDialog": {
        "confirm": {
          "title": "Ønsker du å gjenopprette {{name}}?",
          "description": "Gjenopprettede salgsavtaler kan kobles til oppdrag. Status for salgsavtalen blir beregnet automatisk basert på avtaleperioden.",
          "cancel": "Avbryt",
          "action": "Gjenopprett salgsavtale"
        },
        "errorTitle": "Handlingen kunne ikke fullføres",
        "errorDescription": "Det er for tiden tekniske problemer. Prøv igjen senere."
      },
      "addButton": "Legg til salgsavtale",
      "emptyState": {
        "title": "Ingen salgsavtaler",
        "description": "Det er ikke registrert noen salgsavtaler hos denne tømmerkjøperen.\nTrykk på “Legg til salgsavtale” for å starte prosessen."
      }
    },
    "currentTab": {
      "title": "{{tabName}} kommer i egen deloppgave",
      "description": "Oversikt er implementert nå, og de andre fanene kobles til egne sider.",
      "helper": "Fanestrukturen følger samme mønster som skogeieroversikten."
    }
  },
  "register": {
    "company": {
      "timberbuyerName": {
        "label": "Tømmerkjøper navn"
      }
    },
    "contact": {
      "email": {
        "label": "E-post <i>(valgfritt)</i>",
        "labelRequired": "E-post"
      },
      "phone": {
        "label": "Telefonnummer <i>(valgfritt)</i>"
      }
    },
    "invoicing": {
      "recipientName": {
        "label": "Mottakernavn"
      },
      "email": {
        "labelOptional": "Faktura e-post <i>(valgfritt)</i>"
      }
    }
  },
  "edit": {
    "title": "Endre tømmerkjøperopplysninger",
    "company": {
      "title": "Tømmerkjøperopplysninger",
      "description": "Legg til eller endre opplysninger rundt tømmerkjøper"
    },
    "contact": {
      "emailRequiredByContactPreference": "E-post er påkrevd fordi det er valgt som kontaktpreferanse"
    },
    "success": "Kjøperopplysninger er oppdatert.",
    "saveError": "Kunne ikke lagre endringer. Prøv igjen.",
    "save": "Lagre endringer",
    "cancel": "Avbryt",
    "cancelDialog": {
      "title": "Avbryt uten å lagre?",
      "description": "Endringene dine vil ikke bli lagret.",
      "confirmCancel": "Avbryt uten å lagre",
      "continueEditing": "Fortsett å endre"
    }
  },
  "formFields": {
    "loading": "Laster opp...",
    "transport": {
      "responsible": {
        "loadErrorText": "Kunne ikke laste transportansvarlige"
      },
      "payer": {
        "loadErrorText": "Kunne ikke laste transportbetalere"
      },
      "measurementOrganization": {
        "loadErrorText": "Kunne ikke laste målingsorganisasjoner"
      }
    }
  }
}
